import { ColumnsType } from "antd/es/table";
import { useMemo, useState } from "react";
import DataTable from "..";

/**
 * Wraps DataTable so it can be used with any RTK Query useQuery GET.
 * Client-side search only for now
 */
export default function DataTableQuery<T extends object>(props: {
  query: () => { data?: T[], error?: any, isFetching: boolean, refetch: () => void };
  searchFilter: (obj: T, s: string) => boolean;
  columns: ColumnsType<T>;
  onCreate?: () => void;
}) {
  const { query, searchFilter, columns, onCreate } = props;
  const { data, error, isFetching, refetch } = query();
  const [searchQuery, setSearchQuery] = useState("");
  const filteredData = useMemo(() => {
    if (!data) {
      return [];
    }
    if (searchQuery.length === 0) {
      return data;
    }
    return data.filter(d => searchFilter(d, searchQuery));
  }, [data, searchFilter, searchQuery]);
  return <>
    <DataTable
      columns={columns}
      data={filteredData}
      isFetching={isFetching}
      refetch={refetch}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      error={error}
      onCreate={onCreate}
    />
  </>
}